import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-footer-default',
  templateUrl: './footer-default.component.html',
  styleUrls: ['./footer-default.component.scss']
})
export class FooterDefaultComponent implements OnInit {
  facebookUrl = 'https://www.facebook.com/%D7%91%D7%A2%D7%A7%D7%91%D7%95%D7%AA-%D7%94%D7%98%D7%91%D7%A2-%D7%92%D7%A9%D7%A9%D7%95%D7%AA-%D7%95%D7%9E%D7%95%D7%93%D7%A2%D7%95%D7%AA-%D7%91%D7%98%D7%91%D7%A2-Tracking-and-Nature-Awareness-852263394810249/';
  youtube = `https://www.youtube.com/channel/UCbvnqfuuTDKxQAXsp1JaBng?view_as=subscriber`;
  constructor() { }

  ngOnInit() {
  }

  openExternalUrl() {
    window.open(this.facebookUrl, '_blank');
  }

  openYoutubeUrl() {
    window.open(this.youtube, '_blank');
  }
}
